var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-result',{attrs:{"title":"页面建设中,敬请期待..."},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('a-icon',{attrs:{"type":"smile","theme":"twoTone"}})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }